<template>
  <!-- 法律聚焦-列表页 -->
  <div class="speciallist">
    <div class="speltcont between">
      <lvbreadcrumb class="speltmbx" :tolist="tolist" />
      <div class="specaltleft">
        <speltselec class="common" />
        <speltcontls class="common mt30" />
      </div>
      <div class="specaltright">
        <speltfocblem class="common" :list="gztllist" />
        <spelttjlaw class="common mt30" />
      </div>
    </div>
  </div>
</template>

<script>
import speltselec from "./child/speltselec";
import speltfocblem from "./components/speltfocblem";
import lvbreadcrumb from "components/content/lvbreadcrumb/lvbreadcrumb";
import speltcontls from "./child/speltcontls";
import spelttjlaw from "./components/spelttjlaw";
export default {
  components: {
    speltselec,
    speltfocblem,
    lvbreadcrumb,
    speltcontls,
    spelttjlaw,
  },
  data: () => ({
    gztllist:[]
  }),
  computed: {
    getfljj() {
      return this.$store.state.laws.fljjxx;
    },
    tolist() {
      return [
        {
          name: "法律聚焦",
          path: "/laws/special",
        },
        {
          name: this.getfljj.name,
        },
      ];
    },
  },
  beforeMount() {
    this.getgztl()
  },
  methods:{
    getgztl(){
      let data = {
        limit: 5,
        page: 1,
        order:'hot'
      };
      this.$http.laws.getarticlist(data)
        .then(res => {
          this.gztllist = res.data.data
        })
    }
  }
};
</script>

<style lang="scss" scoped>
.speciallist {
  background-color: #f8f8f8;
  .speltcont {
    padding: 50px 0;
    width: 1200px;
    margin: 0 auto;
    position: relative;
    align-items: flex-start;
    .common {
      background: #ffffff;
    }
    .specaltleft {
      width: 856px;
    }
    .specaltright {
      width: 314px;
    }
    .speltmbx {
      position: absolute;
      top: 20px;
      left: 0;
    }
  }
}
</style>